import { render, staticRenderFns } from "./StatsDemoBikes.vue?vue&type=template&id=91635b94"
import script from "./StatsDemoBikes.vue?vue&type=script&lang=ts"
export * from "./StatsDemoBikes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports